import { apiTransformer } from 'utils';

export const sportsmanToApiTransformer = values => {
    return apiTransformer(values, ['rank', 'qualification', 'trainer', 'profile', 'secondTrainer']);
}
